import { userConstants } from "../../constant";

const initialState = {
  loyalty_tier: "bronze",
  loyalty_tier_display: "Bronze",
  total_lifetime_spent: 0,
  discount_percentage: 0,
  next_tier: null,
  next_tier_threshold: null,
  amount_to_next_tier: 0,
  progress_percentage: 0,
  // Points data
  points_balance: 0,
  total_points_earned: 0,
  total_points_redeemed: 0,
  credits_balance: 0,
  points_tier: "bronze",
  points_tier_display: "Bronze",
  // Transactions
  transactions: [],
  transactions_page: 1,
  transactions_total: 0,
  transactions_total_pages: 0,
  loaded: false,
};

export function buyerLoyalty(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_BUYER_LOYALTY:
      return {
        ...state,
        ...action.payload,
        loaded: true,
      };
    case userConstants.GET_LOYALTY_DASHBOARD:
      return {
        ...state,
        ...action.payload,
        loaded: true,
      };
    case userConstants.GET_LOYALTY_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.transactions,
        transactions_page: action.payload.page,
        transactions_total: action.payload.total,
        transactions_total_pages: action.payload.total_pages,
      };
    case userConstants.LOYALTY_REDEEM:
      return {
        ...state,
        points_balance: action.payload.points_balance,
        credits_balance: action.payload.credits_balance,
      };
    default:
      return state;
  }
}
